export default __webpack_public_path__ + "static/media/close.a7b919fe.svg";